// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router';
import { PrimeReactProvider } from 'primereact/api';
import RegisterForm from './RegisterForm';
import Admin from './admin/Admin';
import Stats from './admin/stats';
import Charon from './Charon';
import Tests from './__tests/test';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import './App.css';

function App() {
  return (
    <PrimeReactProvider>
      <Router>
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-start',
          height: '100vh',
          padding: '20px'
        }}>
          <div className="App">
            <Routes>
              {(process.env.NODE_ENV === "development") ?
                <Route path="/__tests/" element={<Tests />} /> :
                <></>}
              <Route path="/" element={<RegisterForm />} />
              <Route path="/admin/*" element={<Admin />} />
              <Route path="/charon" element={<Charon />} />
              <Route path="/stats" element={<Stats />} />
            </Routes>
          </div>
        </div>
      </Router>
    </PrimeReactProvider>
  );
}

export default App;
